// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sas-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: white;
  overflow-y: auto;
  padding: 20px;
}

.sas-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.sas-header-left {
  flex: 1 1;
  min-width: 300px;
}

.sas-header-left h2 {
  margin: 0 0 4px 0;
  font-size: 20px;
  color: #002FA7;
}

.sas-subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}

.sas-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.sas-export-btn,
.sas-print-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #8aa3c4b8;
  background: white;
  color: #002FA7;
  white-space: nowrap;
}

.sas-export-btn:hover,
.sas-print-btn:hover {
  transform: translateY(-1px);
}

.sas-form {
  flex: 1 1;
}

.sas-form-row {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.sas-form-group {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sas-label {
  font-size: 14px;
  font-weight: 500;
  color: #002FA7;
}

.sas-input,
.sas-select,
.sas-year-select {
  padding: 10px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  background: white;
  cursor: pointer;
  color: #1f2937;
  transition: all 0.2s ease;
}

.sas-input:focus,
.sas-select:focus,
.sas-year-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.sas-input:hover,
.sas-select:hover,
.sas-year-select:hover {
  border-color: #002FA7;
}

.sas-select:disabled {
  background: #f3f4f6;
  cursor: not-allowed;
  opacity: 0.6;
}

.sas-year-select {
  min-width: 120px;
}

.sas-semester-buttons,
.sas-attestation-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.sas-semester-btn,
.sas-attestation-btn {
  padding: 8px 20px;
  border: 1px solid #e2e8f0;
  background: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sas-semester-btn:hover,
.sas-attestation-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.sas-semester-btn.active,
.sas-attestation-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.sas-students-info {
  margin: 24px 0;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.sas-students-info h4 {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.sas-students-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 16px 20px;
  max-height: 470px;
  overflow-y: auto;
}

.sas-student-item {
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  font-size: 13px;
  color: #1f2937;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.sas-student-item:hover {
  background: #f8fafc;
  border-color: #002FA7;
}

.sas-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
}

.sas-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: sas-spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes sas-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.sas-loading-container p {
  color: #64748b;
  font-size: 14px;
}

@media (max-width: 768px) {
  .sas-container {
    padding: 16px;
  }

  .sas-form-row {
    flex-direction: column;
    gap: 16px;
  }

  .sas-form-group {
    min-width: 100%;
  }

  .sas-students-list {
    grid-template-columns: 1fr;
  }

  .sas-semester-buttons,
  .sas-attestation-buttons {
    justify-content: flex-start;
  }

  .sas-actions {
    width: 100%;
  }

  .sas-export-btn,
  .sas-print-btn {
    flex: 1 1;
    text-align: center;
  }

  .sas-year-select,
  .sas-select {
    min-width: 100%;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .sas-container {
    padding: 12px;
  }

  .sas-header-left h2 {
    font-size: 18px;
  }

  .sas-semester-btn,
  .sas-attestation-btn {
    padding: 6px 14px;
    font-size: 13px;
  }

  .sas-student-item {
    font-size: 12px;
    padding: 6px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dh-components/SessionAttestationSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".sas-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.sas-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.sas-header-left {\n  flex: 1;\n  min-width: 300px;\n}\n\n.sas-header-left h2 {\n  margin: 0 0 4px 0;\n  font-size: 20px;\n  color: #002FA7;\n}\n\n.sas-subtitle {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.sas-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.sas-export-btn,\n.sas-print-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n  border: 1px solid #8aa3c4b8;\n  background: white;\n  color: #002FA7;\n  white-space: nowrap;\n}\n\n.sas-export-btn:hover,\n.sas-print-btn:hover {\n  transform: translateY(-1px);\n}\n\n.sas-form {\n  flex: 1;\n}\n\n.sas-form-row {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.sas-form-group {\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.sas-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #002FA7;\n}\n\n.sas-input,\n.sas-select,\n.sas-year-select {\n  padding: 10px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  background: white;\n  cursor: pointer;\n  color: #1f2937;\n  transition: all 0.2s ease;\n}\n\n.sas-input:focus,\n.sas-select:focus,\n.sas-year-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.sas-input:hover,\n.sas-select:hover,\n.sas-year-select:hover {\n  border-color: #002FA7;\n}\n\n.sas-select:disabled {\n  background: #f3f4f6;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.sas-year-select {\n  min-width: 120px;\n}\n\n.sas-semester-buttons,\n.sas-attestation-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.sas-semester-btn,\n.sas-attestation-btn {\n  padding: 8px 20px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sas-semester-btn:hover,\n.sas-attestation-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.sas-semester-btn.active,\n.sas-attestation-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.sas-students-info {\n  margin: 24px 0;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n}\n\n.sas-students-info h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.sas-students-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  padding: 16px 20px;\n  max-height: 470px;\n  overflow-y: auto;\n}\n\n.sas-student-item {\n  padding: 8px 12px;\n  background: white;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #1f2937;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.sas-student-item:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n}\n\n.sas-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n}\n\n.sas-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: sas-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes sas-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.sas-loading-container p {\n  color: #64748b;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .sas-container {\n    padding: 16px;\n  }\n\n  .sas-form-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .sas-form-group {\n    min-width: 100%;\n  }\n\n  .sas-students-list {\n    grid-template-columns: 1fr;\n  }\n\n  .sas-semester-buttons,\n  .sas-attestation-buttons {\n    justify-content: flex-start;\n  }\n\n  .sas-actions {\n    width: 100%;\n  }\n\n  .sas-export-btn,\n  .sas-print-btn {\n    flex: 1;\n    text-align: center;\n  }\n\n  .sas-year-select,\n  .sas-select {\n    min-width: 100%;\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .sas-container {\n    padding: 12px;\n  }\n\n  .sas-header-left h2 {\n    font-size: 18px;\n  }\n\n  .sas-semester-btn,\n  .sas-attestation-btn {\n    padding: 6px 14px;\n    font-size: 13px;\n  }\n\n  .sas-student-item {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
